import PropTypes from 'prop-types'
import { Label } from '@components/ui/label'
import { cn } from 'lib/utils'

export const AdasInputLabel = ({
  children,
  className,
  htmlFor,
  error,
  required,
  // eslint-disable-next-line no-unused-vars
  sx,
  // eslint-disable-next-line no-unused-vars
  shrink,
  // eslint-disable-next-line no-unused-vars
  id,
  ...props
}) => (
  <Label htmlFor={htmlFor} className={cn('text-xs font-medium text-text-primary', error && 'text-error', className)} {...props}>
    {children}
    {required && <span className='text-error ml-1'>*</span>}
  </Label>
)

AdasInputLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  htmlFor: PropTypes.string,
  error: PropTypes.bool,
  required: PropTypes.bool
}
